import { parseEnv } from '@nohara-dxdev/react-core';
import z from 'zod';

/**
 * Whether this build targets a developer environment (local or the dev stage).
 *
 * Written as literal comparisons on `import.meta.env` so the bundler folds it to a constant
 * at build time: code behind this flag is dropped from the production bundle entirely, not
 * merely hidden at runtime.
 */
export const IS_DEV_ENVIRONMENT =
  import.meta.env.VITE_ENVIRONMENT === 'local' ||
  import.meta.env.VITE_ENVIRONMENT === 'development';

export const env = parseEnv({
  HOME_API_ENDPOINT: z.string().url(),
  API_ENDPOINT: z.string().url(),
  OAUTH_DOMAIN: z.string(),
  APP_ID: z.string().uuid(),
  USER_POOL_ID: z.string(),
  USER_POOL_WEB_CLIENT_ID: z.string(),
  OIDC_CALLBACK_PATH: z.string().default('/oauth/callback'),
  SIGN_OUT_PATH: z.string().default('/logout'),
  // only set when monitoring is enabled for this stage (prod/stage)
  RUM_APP_MONITOR_ID: z.string().optional(),
  RUM_IDENTITY_POOL_ID: z.string().optional(),
  RUM_REGION: z.string().optional(),
});
